import { render } from "./EditAnggotaKeluarga.vue?vue&type=template&id=2332a92a&scoped=true"
import script from "./EditAnggotaKeluarga.vue?vue&type=script&lang=js"
export * from "./EditAnggotaKeluarga.vue?vue&type=script&lang=js"

import "./EditAnggotaKeluarga.vue?vue&type=style&index=0&id=2332a92a&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2332a92a"]])

export default __exports__